<template>
  <div>
    <p>ページが見つかりません</p>
  </div>
</template>

<script>
export default {
  name: "NotFoundComponent",
  mounted: function() {
    document.title = `ページが見つかりません`;
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", `ページが見つかりません`);
  }
};
</script>